// extracted by mini-css-extract-plugin
export default {"container":"RealPlayInfo_container__LOebs","scenario":"RealPlayInfo_scenario__XKuUr","ratingCriteriaRep":"RealPlayInfo_ratingCriteriaRep__YCvIq"};